import React, { useState, useEffect } from 'react';
import RichTable from '../components/richTable/RichTable.jsx'
import TableHelpers from '../helpers/TableHelpers.js';
import Dropdown from 'react-bootstrap/Dropdown';

function PlanCompare(props) {

    const [plans, setPlans] = useState([]);
    const [allocations, setAllocations] = useState([]);
    const [selectedPlanId, setSelectedPlanId] = useState(null);
    const [compareAllocations, setCompareAllocations] = useState([]);
    const [filterSymbol, setFilterSymbol] = useState('All');
    const [filterAlgoType, setFilterAlgoType] = useState('All');
    const [years, setYears] = useState(10);

    useEffect(() => {
        (async function () {
            setAllocations([]);

            let planData = await (await fetch(`/api/subscriptions?userId=` + props.userId)).json();
            setPlans(planData);

            let text = await (await fetch(`/api/algos?planId=` + props.planId + `&years=` + years)).json();
            console.log("original plan", text);
            setAllocations(text.filter(a => a.percentage > 0));
        })();
    }, [props.planId, props.userId, years]);

    useEffect(() => {
        (async function () {
            if (selectedPlanId) {
                setCompareAllocations([]);
                let text = await (await fetch(`/api/algos?planId=` + selectedPlanId + `&years=` + years)).json();
                console.log("other plan", text);
                setCompareAllocations(text.filter(a => a.percentage > 0));
            } else {
                setCompareAllocations([]);
            }
        })();
    }, [selectedPlanId, years]);

    const uniqueSymbols = [...new Set([...allocations, ...compareAllocations].map(a => a.trade_symbol))].sort();
    const uniqueAlgoTypes = [...new Set([...allocations, ...compareAllocations].map(a => a.algo_type))].sort();

    const filteredAllocations = allocations.filter(a =>
        (filterSymbol === 'All' || a.trade_symbol === filterSymbol) &&
        (filterAlgoType === 'All' || a.algo_type === filterAlgoType)
    );

    const filteredCompareAllocations = compareAllocations.filter(a =>
        (filterSymbol === 'All' || a.trade_symbol === filterSymbol) &&
        (filterAlgoType === 'All' || a.algo_type === filterAlgoType)
    );

    function getExactMatches() {
        return filteredAllocations.filter(a => {
            let comp = filteredCompareAllocations.find(c => c.idalgos === a.idalgos);
            return comp && comp.percentage === a.percentage;
        }).map(a => ({ ...a, net_cagr: (a.cagr || 0) * (a.percentage / 100) }));
    }

    function getDiffAllocations() {
        let results = [];
        filteredAllocations.forEach(a => {
            let comp = filteredCompareAllocations.find(c => c.idalgos === a.idalgos);
            if (comp && comp.percentage !== a.percentage) {
                results.push({
                    ...a,
                    compare_percentage: comp.percentage,
                    net_cagr: (a.cagr || 0) * (a.percentage / 100),
                    compare_net_cagr: (a.cagr || 0) * (comp.percentage / 100),
                    net_cagr_diff: ((a.cagr || 0) * (a.percentage / 100)) - ((a.cagr || 0) * (comp.percentage / 100))
                });
            }
        });
        return results;
    }

    function getMissingFromOriginal() {
        return filteredCompareAllocations.filter(c => !filteredAllocations.find(a => a.idalgos === c.idalgos)).map(c => ({ ...c, net_cagr: (c.cagr || 0) * (c.percentage / 100) }));
    }

    function getMissingFromSelected() {
        return filteredAllocations.filter(a => !filteredCompareAllocations.find(c => c.idalgos === a.idalgos)).map(a => ({ ...a, net_cagr: (a.cagr || 0) * (a.percentage / 100) }));
    }

    function getAggregatedAllocations() {
        let aggregation = {};

        filteredAllocations.forEach(a => {
            let key = a.trade_symbol + "_" + a.algo_type;
            if (!aggregation[key]) {
                aggregation[key] = { trade_symbol: a.trade_symbol, algo_type: a.algo_type, original_total: 0, compare_total: 0, original_cagr: 0, compare_cagr: 0, cagr_diff: 0 };
            }
            aggregation[key].original_total += a.percentage;
            aggregation[key].original_cagr += (a.cagr || 0) * (a.percentage / 100);
            aggregation[key].cagr_diff += (a.cagr || 0) * (a.percentage / 100);
        });

        filteredCompareAllocations.forEach(a => {
            let key = a.trade_symbol + "_" + a.algo_type;
            if (!aggregation[key]) {
                aggregation[key] = { trade_symbol: a.trade_symbol, algo_type: a.algo_type, original_total: 0, compare_total: 0, original_cagr: 0, compare_cagr: 0, cagr_diff: 0 };
            }
            aggregation[key].compare_total += a.percentage;
            aggregation[key].compare_cagr += (a.cagr || 0) * (a.percentage / 100);
            aggregation[key].cagr_diff -= (a.cagr || 0) * (a.percentage / 100);
        });

        return Object.values(aggregation).sort((a, b) => a.cagr_diff - b.cagr_diff);
    }

    let selectedPlan = plans.find(p => p.planId === Number(selectedPlanId));
    let selectedPlanName = selectedPlan ? selectedPlan.name : "Select a Plan to Compare...";

    return (
        <div style={{ padding: "20px" }}>
            <center>
                <div className="sameline">
                    <Dropdown onSelect={(e) => setSelectedPlanId(e)}>
                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                            {selectedPlanName}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {plans.filter(p => p.planId !== props.planId).map(p => (
                                <Dropdown.Item key={p.planId} eventKey={p.planId}>{p.name}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    <br></br><br></br>
                    <Dropdown onSelect={(e) => setYears(Number(e))}>
                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                            {years === 0 ? "Live Trades" : years + " Years"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item eventKey={0}>Live Trades</Dropdown.Item>
                            <Dropdown.Item eventKey={1}>1 Year</Dropdown.Item>
                            <Dropdown.Item eventKey={2}>2 Years</Dropdown.Item>
                            <Dropdown.Item eventKey={3}>3 Years</Dropdown.Item>
                            <Dropdown.Item eventKey={5}>5 Years</Dropdown.Item>
                            <Dropdown.Item eventKey={10}>10 Years</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {selectedPlanId && compareAllocations.length ? (
                        <>
                            <br></br><br></br>Filters: &nbsp;
                            <Dropdown onSelect={(e) => setFilterSymbol(e)}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    Symbol: {filterSymbol}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="All">All</Dropdown.Item>
                                    {uniqueSymbols.map(s => <Dropdown.Item key={s} eventKey={s}>{s}</Dropdown.Item>)}
                                </Dropdown.Menu>
                            </Dropdown>
                            &nbsp;
                            <Dropdown onSelect={(e) => setFilterAlgoType(e)}>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                    Type: {filterAlgoType}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="All">All</Dropdown.Item>
                                    {uniqueAlgoTypes.map(t => <Dropdown.Item key={t} eventKey={t}>{t}</Dropdown.Item>)}
                                </Dropdown.Menu>
                            </Dropdown>
                        </>
                    ) : null}
                </div>
            </center>

            {selectedPlanId && compareAllocations.length ? (
                <>
                    <br />
                    <h4>Aggregated by Symbol & Algo Type</h4>
                    <RichTable showTotalRow={true} data={getAggregatedAllocations()} className="table-striped table-hover table-condensed" mappers={[
                        { title: 'Symbol', field: 'trade_symbol', sorters: true },
                        { title: 'Type', field: 'algo_type', sorters: true },
                        { title: 'Original Total', field: 'original_total', formatter: TableHelpers.percentFormatterNoDecimals, sorters: true },
                        { title: 'Compared Total', field: 'compare_total', formatter: TableHelpers.percentFormatterNoDecimals, sorters: true },
                        { title: 'Net CAGR Diff', field: 'cagr_diff', formatter: TableHelpers.percentChangeFormatterOneDecimal, sorters: true }]} />

                    <br />
                    <h4>Same Algos & Allocations</h4>
                    <RichTable showTotalRow={true} data={getExactMatches()} className="table-striped table-hover table-condensed" mappers={[
                        { title: 'Algo ID', field: 'idalgos', sorters: true },
                        { title: 'Name', field: 'display_name', sorters: true },
                        { title: 'Symbol', field: 'trade_symbol', sorters: true },
                        { title: 'Allocation', field: 'percentage', formatter: TableHelpers.percentFormatterNoDecimals, sorters: true },
                        { title: 'Net CAGR', field: 'net_cagr', formatter: TableHelpers.percentFormatter, sorters: true }]} />

                    <br />
                    <h4>Same Algos, Different Allocations</h4>
                    <RichTable showTotalRow={true} data={getDiffAllocations()} className="table-striped table-hover table-condensed" mappers={[
                        { title: 'Algo ID', field: 'idalgos', sorters: true },
                        { title: 'Name', field: 'display_name', sorters: true },
                        { title: 'Symbol', field: 'trade_symbol', sorters: true },
                        { title: 'Original Allocation', field: 'percentage', formatter: TableHelpers.percentFormatterNoDecimals, sorters: true },
                        { title: 'Compared Allocation', field: 'compare_percentage', formatter: TableHelpers.percentFormatterNoDecimals, sorters: true },
                        { title: 'Net CAGR Diff', field: 'net_cagr_diff', formatter: TableHelpers.percentFormatter, sorters: true }]} />

                    <br />
                    <h4>Missing from Original Plan</h4>
                    <RichTable showTotalRow={true} data={getMissingFromOriginal()} className="table-striped table-hover table-condensed" mappers={[{ title: 'Algo ID', field: 'idalgos', sorters: true }, { title: 'Name', field: 'display_name', sorters: true }, { title: 'Symbol', field: 'trade_symbol', sorters: true }, { title: 'Compared Allocation', field: 'percentage', formatter: TableHelpers.percentFormatterNoDecimals, sorters: true }, { title: 'Net CAGR', field: 'net_cagr', formatter: TableHelpers.percentFormatter, sorters: true }]} />

                    <br />
                    <h4>Missing from Selected Plan</h4>
                    <RichTable showTotalRow={true} data={getMissingFromSelected()} className="table-striped table-hover table-condensed" mappers={[{ title: 'Algo ID', field: 'idalgos', sorters: true }, { title: 'Name', field: 'display_name', sorters: true }, { title: 'Symbol', field: 'trade_symbol', sorters: true }, { title: 'Original Allocation', field: 'percentage', formatter: TableHelpers.percentFormatterNoDecimals, sorters: true }, { title: 'Net CAGR', field: 'net_cagr', formatter: TableHelpers.percentFormatter, sorters: true }]} />
                </>
            ) : null}
        </div >
    );
}

export default PlanCompare;